import React, { PureComponent, Fragment } from 'react';
import { withApi } from '../../context/AppContext';
import Description from '../../components/Description';
import LoadingTooltip from '../../components/LoadingTooltip';
import './Player.css';

class Player extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showLoadingTooltip: false };
    this.loadingTooltipDelay = undefined;
    this.loadingTooltipTimer = undefined;
  }

  componentWillReceiveProps(newProps) {
    const { showLoadingTooltip } = this.state;
    const { appApi } = newProps;
    if (appApi && !this.props.appApi) {
      const toolInfo = appApi.tool.getToolSpecification('loadingTooltip');
      this.loadingTooltipDelay = Number(toolInfo.delay) || 0;
    }
    if (newProps.disabled && !this.props.disabled)
      this.loadingTooltipTimer = this.showTooltip();

    if (!newProps.disabled) {
      if (this.loadingTooltipTimer) clearTimeout(this.loadingTooltipTimer); // clear the timeout
      if (showLoadingTooltip) this.setState({ showLoadingTooltip: false });
      this.loadingTooltipTimer = undefined;
    }
  }
  showTooltip = () => {
    if (this.loadingTooltipDelay)
      return setTimeout(
        () => this.setState({ showLoadingTooltip: true }),
        this.loadingTooltipDelay
      );
    this.setState({ showLoadingTooltip: true });
  };

  render() {
    const { showLoadingTooltip } = this.state;

    return (
      <Fragment>
        {showLoadingTooltip && (
          <div id="loadingTooltip">
            <LoadingTooltip {...this.props} />
          </div>
        )}
        <div id="logo">
          <img
            src="https://s3.ca-central-1.amazonaws.com/preferred.clara.io/clients/bostontec/static/assets/logo.jpg"
            style={{ width: '100%' }}
          />
        </div>
        <div id="player" />
        <div id="description">
          {this.props.selectedModel && <Description {...this.props} />}
        </div>
      </Fragment>
    );
  }
}

export default withApi(Player);



// WEBPACK FOOTER //
// ./src/containers/Player/index.js